import odogwuHunterImg from "./hammer-games-assets/Odogwu-Hunter-min.png"
import gigLogistics from "./gig-logistics.png"
import xendFinance from "./xend-new-cover.png"
import freightSync from "./freight-sync.png"

const myPhoto = "https://res.cloudinary.com/code-messiah/image/upload/v1679749388/muhyideen-portfoli-website-images/headshot-min_jmzdsc.jpg"
const launchpad = "https://res.cloudinary.com/code-messiah/image/upload/v1679928150/muhyideen-portfoli-website-images/Xend-Launchpad-1024x592_m6ajv0.jpg"
const xendSavings = "https://res.cloudinary.com/code-messiah/image/upload/v1679928764/muhyideen-portfoli-website-images/Screenshot_2023-03-27_at_3.52.10_PM_pdmwbf.png"
const pinnacleMembers = "https://res.cloudinary.com/code-messiah/image/upload/v1679928598/muhyideen-portfoli-website-images/Screenshot_2023-03-27_at_3.46.40_PM_nmfwqi.png"
const rocket = "https://res.cloudinary.com/code-messiah/image/upload/v1679927495/muhyideen-portfoli-website-images/Screenshot_2023-03-27_at_2.35.12_PM_sshz0x.png"
const verifiedCreators = "https://res.cloudinary.com/code-messiah/image/upload/v1679927597/muhyideen-portfoli-website-images/verified_jvpxhl.png"
const madwalletExtension = "https://res.cloudinary.com/code-messiah/image/upload/v1679927673/muhyideen-portfoli-website-images/madwallet-cover-img_yywdgg.jpg"
const xendWebsite = "https://res.cloudinary.com/code-messiah/image/upload/v1679929163/muhyideen-portfoli-website-images/Screenshot_2023-03-27_at_3.58.51_PM_zn22zz.png"
const fittedTailors = "https://res.cloudinary.com/code-messiah/image/upload/v1679928953/muhyideen-portfoli-website-images/Screenshot_2023-03-27_at_3.55.17_PM_jp3cq6.png"



export {
    myPhoto,
    launchpad,
    xendSavings,
    pinnacleMembers,
    rocket,
    verifiedCreators,
    madwalletExtension,
    xendWebsite,
    fittedTailors,
    odogwuHunterImg,
    xendFinance,
    freightSync,
    gigLogistics
}